/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import Wait from '@react/react-spectrum/Wait';
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import './TransitionScreen.scss';

type Props = {
	bootstrapCompleted: boolean;
	isCCD: boolean;
};

type State = {
	showTransitionMessage: boolean;
};

class TransitionScreen extends Component<Props, State> {
	showFirstVisitTransitionPage: boolean;

	constructor(props: Props) {
		super(props);
		this.state = {
			showTransitionMessage: true,
		};
		this.showFirstVisitTransitionPage
			= window.cchome.util.storageAvailable('localStorage')
			&& !(localStorage.getItem('showFirstVisitTransitionPage') === 'false');
		window.cchome.util.setIsFirstVisit(this.showFirstVisitTransitionPage);
	}

	componentDidMount() {
		if (window.cchome.util.storageAvailable('localStorage')) {
			localStorage.setItem('showFirstVisitTransitionPage', 'false');
		}
		setTimeout(() => {
			this.setState({showTransitionMessage: false});
		}, 2500);
	}

	componentWillUnmount() {
		document.getElementsByTagName('body')[0].classList.remove('bodyOverflowHidden');
	}

	isAppsURL() {
		const path = window.location.pathname.split('/');
		if (path[1] === 'apps' || this.props.isCCD) {
			return true;
		}
		return false;
	}

	renderTransitionMessage() {
		/* istanbul ignore else */
		if (
			this.showFirstVisitTransitionPage
			&& (this.state.showTransitionMessage || !this.props.bootstrapCompleted || this.isAppsURL())
		) {
			return (
				<div className='transition-screen-message'>
					<FormattedMessage id='app.transition.screen.message' />
				</div>
			);
		}
	}

	addBodyOverflowHidden() {
		// Bug 4682
		// Only add bodyOverflowHidden when the transition-screen-wrapper is displayed
		const transitionScreenWrapper: HTMLElement | null = document.querySelector('.transition-screen-wrapper');

		/* istanbul ignore else */
		if (!transitionScreenWrapper || (transitionScreenWrapper && transitionScreenWrapper.style.display !== 'none')) {
			document.getElementsByTagName('body')[0].classList.add('bodyOverflowHidden');
		}
	}

	render() {
		const domArr: JSX.Element[] = [];

		/* istanbul ignore else */
		if (
			(this.showFirstVisitTransitionPage && this.state.showTransitionMessage)
			|| !this.props.bootstrapCompleted
			|| this.isAppsURL()
		) {
			this.addBodyOverflowHidden();
			domArr.push(
				<div key='transitionPage' className={`transition-screen-wrapper${this.isAppsURL() ? ' apps' : ''}`}>
					<div className='transition-screen-container'>
						<Wait className='spinner' centered size='L' />
						{!this.props.isCCD && this.renderTransitionMessage()}
					</div>
				</div>,
			);
		}
		else {
			document.getElementsByTagName('body')[0].classList.remove('bodyOverflowHidden');
		}
		return domArr;
	}
}

function mapStateToProps(state) {
	return {
		bootstrapCompleted: state.auth.bootstrapCompleted,
	};
}

export default connect(mapStateToProps)(TransitionScreen);
